import clsx from "clsx";
import {
  AnimatePresence,
  m,
} from "framer-motion";
import type { FunctionComponent } from "react";

interface FloatMenuProps {
  children: React.ReactNode;
  menuOpen: boolean;
}

export const FloatMenu: FunctionComponent<
  FloatMenuProps
> = ({ children, menuOpen }) => {
  return (
    <AnimatePresence>
      {menuOpen && (
        <m.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          exit={{
            opacity: 0,
          }}
          className={clsx(
            "absolute",
            "w-100",
            "bg-white",
            "border",
            "border-gray-300",
            "-right-5",
            "-top-11",
            "text-14",
            "rounded-sm",
            /*  */
          )}
        >
          {children}
        </m.div>
      )}
    </AnimatePresence>
  );
};
